import { useContext } from 'react';

import { DraggingContext } from '../contexts/DraggingContext';

/**
 * Hook to access the current dragging state
 * @returns {boolean} indicating if any item is currently being dragged
 */

export const useDraggingContext = () => {
  const context = useContext(DraggingContext);

  if (!context) throw new Error('useDraggingContext must be used inside DraggingProvider');

  return context;
};
